import Cookies from "js-cookie";

export function getToken() {
  let token = '';
  if (process.env.VUE_APP_ENV !== 'development') {
    token = Cookies.get('token', { domain: '.591ylc.com' });
  } else {
    token = Cookies.get('token');
  }
  return token;
}

export function setToken(token) {
  if (process.env.VUE_APP_ENV !== 'development') {
    Cookies.set('token', token, { expires: 1, domain:'.591ylc.com' });
  } else {
    Cookies.set('token', token, { expires: 1 });
  }
}

export function removeToken() {
  if (process.env.VUE_APP_ENV !== 'development') {
    Cookies.remove('token', { domain: '.591ylc.com' });
  } else {
    Cookies.remove('token');
  }
}

/**
 * @description: 是否已展示过首页首访登录引导（Cookie 存储，localStorage.clear() 不会清除）
 */
export function getGuideSeen() {
  return Cookies.get('ylc_home_login_guide_done');
}

/**
 * @description: 记录首页首访登录引导已展示（有效期 365 天，host 级）
 */
export function setGuideSeen() {
  Cookies.set('ylc_home_login_guide_done', '1', { expires: 365 });
}
